import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
const AsideContentLayout = ({ asideContent, mainContent }) => {
    return (_jsxs("div", { className: "aside-content-layout", children: [_jsx("div", { className: "main-content-column", children: mainContent }), _jsx("aside", { className: "aside-content-column", children: asideContent })] }));
};
export default AsideContentLayout;
